import { GridCellParams } from "@mui/x-data-grid";
import { UseRecordsOptions } from "../../api/useRecords";
import { filterUsersRoles } from "../../utils/filterUsersRoles";
import { calculateEvaluationAverage } from "./utils";
import { Typography } from "@mui/material";

export const staffKpisOptions = {
    fieldsToRemove: {
        fieldNamesToRemove: ["id", "content"],
        fieldTypesToRemove: ["alias"],
    },
    groupsOptions: {
        fieldsWithExtraOptions: [
            {
                field: "user",
                filter: filterUsersRoles,
                enabled: true,
            },
            {
                field: "notes",
                charactersLimit: 10000
            },
        ],
    },
    dataGridOptions: {
        extraColumns: {
            beggining: [
                {
                    field: "average",
                    headerName: "Média",
                    width: 75,
                    renderCell: (params: GridCellParams) => {
                        const average = calculateEvaluationAverage(
                            params.row.teamwork,
                            params.row.client_relationship,
                            params.row.autonomy,
                            params.row.critical_thinking
                        );
                        return <Typography variant="body1">{average}</Typography>;
                    },
                },
            ],
        },
    },
    extraOptions: {
        sort: "-month",
    },
} as unknown as UseRecordsOptions;
